import React, { useState, useEffect, useRef } from "react";
import './enqueryForm.css'
import Multiselect from 'multiselect-react-dropdown';
import { useForm, Controller } from 'react-hook-form';
import validationRules from '../../util/validationRules/ValidationRules';

import { post, get } from '../../util/axiosConfig/AxiosConfig'
import Loader from '.././../util/preloader/Preloader';
import showAlert from "../alert/Alert";
import axios from "axios";
import { ENV } from '../../util/Env';
import { useNavigate } from 'react-router-dom';

import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import Header from "../layout/Header";
import Footer from "../layout/Footer";



const EnqueryForm = () => {

    const { control, handleSubmit, register, setValue, formState: { errors }, reset, setError, trigger, clearErrors } = useForm();
    const datePickerRef = useRef(null);
    const navigate = useNavigate();

    // Calculate the minimum date (current date + 2 days)
    const minSelectableDate = new Date();
    minSelectableDate.setDate(minSelectableDate.getDate() + 3);

    const [placeholder, setPlaceholder] = useState("Select courses");
    const [loading, setLoading] = useState(false);

    const [agreement, setAgreement] = useState(true);
    const [allIndustry, setAllIndustry] = useState([]);
    const [allUserRange, setAllUserRange] = useState([]);
    const [coursesList, setCoursesList] = useState([]);
    const [defaultSelectedCourses, setDefaultSelectedCourses] = useState([]);

    const [countries, setCountries] = useState([]);
    const [selectedCountry, setSelectedCountry] = useState("+91");
    const [selectedFlag, setSelectedFlag] = useState('');
    const [selectedIDD, setSelectedIDD] = useState('');

    const [allDates, setAllDates] = useState([
        {id : 1, label : "Immediately", value: "Immediately"},
        {id : 2, label : "In next 30 days", value: "In next 30 days"},
        {id : 3, label : "1-3 months", value: "1-3 months"},
        {id : 4, label : "3-6 months", value: "3-6 months"},
        {id : 5, label : "6-12 months", value: "6-12 months"},
        {id : 6, label : "Not sure", value: "Not sure"}
    ]);

    useEffect(() => {
        window.scrollTo(0, 0);
        fetchMasterdata('admin/api/v1/lms-admin/course/enquiry/industryMaster/getAllIndustry', setAllIndustry);
        fetchMasterdata('admin/api/v1/lms-admin/course/enquiry/userCountRangeMaster/getAllUserCountRange', setAllUserRange);
    }, [])

    useEffect(() => {
        fetchCountryCodeAndFlag();
        fetchCourseList();
    }, []);

    useEffect(() => {
        const country = countries.find((country) => {
            const iddCode = country.idd && country.idd.suffixes && country.idd.suffixes[0]
                ? `${country.idd.root}${country.idd.suffixes[0]}`
                : null;
            return iddCode === selectedCountry;
        });
        if (country) {
            setSelectedFlag(country.flags ? country.flags[0] : "");
            setSelectedIDD(
                country.idd && country.idd.suffixes && country.idd.suffixes[0]
                    ? `${country.idd.root}${country.idd.suffixes[0]}`
                    : "N/A"
            );
        }
    }, [selectedCountry, countries]);

    const getQueryParam = (param) => {
        const urlParams = new URLSearchParams(window.location.search);
        return urlParams.get(param);
    }

    // Fetch course list
    const fetchCourseList = async () => {
        const courseCategory = getQueryParam('cataGory');

        if(courseCategory){
            console.log('With course category')
            try {
                // setLoading(true);
                //web/api/v1/lms-web/open/get-course-list-by-category-id/${courseCategory}
                const response = await get(`web/api/v1/lms-web/open/get-course-list`);
                setCoursesList(response);
    
                const userSelectedCourseId = getQueryParam('courseId');
                const courseIdStr = String(userSelectedCourseId).trim();
                const defaultCourse = response.find(course => String(course.id) === courseIdStr);
                if (defaultCourse) {
                    setDefaultSelectedCourses([defaultCourse]);
                    setValue('courseList', [defaultCourse]);
                }
            } catch (error) {
                setLoading(false);
                console.error(error);
            } finally {
                setLoading(false);
            }
        }else{
            console.log('No course category')
            try {
                // setLoading(true);
                const response = await get(`web/api/v1/lms-web/open/get-course-list`);
                setCoursesList(response);
    
                const userSelectedCourseId = getQueryParam('courseId');
                const courseIdStr = String(userSelectedCourseId).trim();
                const defaultCourse = response.find(course => String(course.id) === courseIdStr);
                if (defaultCourse) {
                    setDefaultSelectedCourses([defaultCourse]);
                    setValue('courseList', [defaultCourse]);
                }
            } catch (error) {
                setLoading(false);
                console.error(error);
            } finally {
                setLoading(false);
            }
        }
    };


    // Fetch country code and Flag
    const fetchCountryCodeAndFlag = async () => {
        try {
            // setLoading(true);
            const response = await get("https://restcountries.com/v3/all");
            setCountries(response);

            // Find India from the response and set it as the default
            const india = response.find((country) => {
                const iddCode = country.idd && country.idd.suffixes && country.idd.suffixes[0]
                    ? `${country.idd.root}${country.idd.suffixes[0]}`
                    : null;
                return iddCode === "+91";
            });

            if (india) {
                setSelectedCountry("+91");
                setSelectedFlag(india.flags ? india.flags[0] : "");
                setValue('location', "+91");
                setSelectedIDD(
                    india.idd && india.idd.suffixes && india.idd.suffixes[0]
                        ? `${india.idd.root}${india.idd.suffixes[0]}`
                        : "N/A"
                );
            }
        } catch (error) {
            console.error(error);
        } finally {
            setLoading(false);
        }
    };

    // const courseOptions = [
    //     { id: '1', course: 'course 1' },
    //     { id: '2', course: 'course 2' },
    //     { id: '3', course: 'course 3' },
    //     { id: '4', course: 'course 4' },
    //     { id: '5', course: 'course 5' },
    //     { id: '6', course: 'course 6' },
    //     { id: '7', course: 'course 7' },
    //     { id: '8', course: 'course 8' }
    // ]

    const fetchMasterdata = async (api, stateToStore) => {
        try {
            // setLoading(true);
            const response = await get(api);
            stateToStore(response);
        } catch (error) {
            setLoading(false);
            console.error(error);
        } finally {
            setLoading(false);
        }
    };

    function validateEmail(email) {
        const emailPattern = /^(?!.*\.\.)(?!.*\.$)(?!.*@.*\.\.)(?!.*\.\@)[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return emailPattern.test(email);
    }

    // const onSubmit = async (data) => {

    //         if (validateEmail(data.email)) {
    //         setError("email", {
    //             type: "manual",
    //             message: "Input a valid email"
    //         });
    //     } else {
    //         alert('valid')
    //     }
    // };


    const onSubmit = data => {

        if (!data.email) {
            setError("email", {
                type: "manual",
                message: "Type a valid email"
            });
        } else {
            const formData = {
                ...data,
                optForNewsLetter: agreement,
                enquiryType : "Organization"
            };

            const sendData = async () => {
                try {
                    setLoading(true);
                    const response = await post('admin/api/v1/lms-admin/course/enquiry/create', formData);
                    setLoading(false);
                    if (response.message == 'Created') {
                        showAlert('Great!', ' Enquiry details has been submitted. Our team will get back to you soon!', 'success', 'OK', false, false, activityCallback, false, 'Cancel', '');
                    } else {
                        showAlert('Abort!', `Unable to submit enquiry data`, 'error', 'Ok', false, false, '', false, '', '');
                    }

                } catch (error) {
                    showAlert('Abort!', ' Unable to submit enquiry data', 'error', 'Ok', false, false, '', false, '', '');
                    setLoading(false);
                    setError(error.response.data)
                } finally {
                    setLoading(false);
                }
            };
            sendData();
        }
    };

    const activityCallback = () => {
        navigate('/Home')
    }

    const handleSelect = (selectedList) => {
        if (selectedList.length >= 3) {
            setPlaceholder("");
        } else {
            setPlaceholder("Select more courses");
        }
    };

    const handleRemove = (selectedList) => {
        if (selectedList.length < 3) {
            setPlaceholder("Select more courses");
        }
    };

    const handleAgreementChange = (event) => {
        setAgreement(event.target.checked)
    }

    const handleCountryCodeChange = (event) => {
        const countryCode = event.target.value;
        setValue('phone', '');
        clearErrors('phone');
        setSelectedCountry(countryCode)
        setValue('location', countryCode)
        clearErrors('location');
    }


    const phoneValidationRules = selectedCountry === '+91' ? {
        required: "Phone number is required",
        pattern: {
            value: /^[1-9]\d{9}$/,
            message: "Invalid phone number",
        },
        maxLength: {
            value: 10,
            message: "Phone number cannot exceed 10 digits",
        }
    } : {
        required: "Phone number is required",
        pattern: {
            value: /^[1-9]\d{6,9}$/,
            message: "Invalid phone number",
        },
        minLength: {
            value: 7,
            message: "Phone number must be at least 7 digits",
        },
        maxLength: {
            value: 10,
            message: "Phone number cannot exceed 10 digits",
        }
    };


    return (
        <React.Fragment>
            {loading ? (
                <Loader />
            ) : (
                <>
                    <Header />
                    <div className="enqueryForm_main">
                        <div className="container">
                            <div className="enquery_form_title_main">
                                <h1 className="form_title">Enquiry Form
                                    {/* <span className="title_icon"><i className="fa-solid fa-book"></i></span> */}
                                </h1>
                                <p className="enquery_form_descripton">Are you looking for a training course tailored to your team's needs? Do you require diverse and customized content? Fill out this form, and our team will promptly get back to you with a solution that fits your requirements.</p>
                            </div>

                            <form onSubmit={handleSubmit(onSubmit)}>
                                <div className="row">
                                    <div className="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-xs-12">
                                        <div className="mb-3">
                                            <label for="idFirstName" class="form-label">First Name<span className="text-danger">*</span></label>
                                            <input
                                                type="text"
                                                className="form-control cstm_fromControl"
                                                id="idFirstName"
                                                aria-describedby="idFirstName"
                                                placeholder="Enter first name*"
                                                name="firstName"
                                                {...register('firstName', {
                                                    required: "First name is required",
                                                    pattern: {
                                                        value: validationRules.firstName.pattern,
                                                        message: validationRules.firstName.message,
                                                    },
                                                })}
                                            />
                                            {errors.firstName && (
                                                <p className="error-message text-danger">{errors.firstName.message}</p>
                                            )}
                                        </div>
                                    </div>

                                    <div className="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-xs-12">
                                        <div className="mb-3">
                                            <label for="idLastName" class="form-label">Last Name<span className="text-danger">*</span></label>
                                            <input
                                                type="text"
                                                className="form-control cstm_fromControl"
                                                id="idLastName"
                                                aria-describedby="idLastName"
                                                placeholder="Enter last name*"
                                                name="lastName"
                                                {...register('lastName', {
                                                    required: "Last name is required",
                                                    pattern: {
                                                        value: validationRules.lastName.pattern,
                                                        message: validationRules.lastName.message,
                                                    },
                                                })}
                                            />
                                            {errors.lastName && (
                                                <p className="error-message text-danger">{errors.lastName.message}</p>
                                            )}
                                        </div>
                                    </div>

                                    <div className="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12">
                                        <div className="mb-3">
                                            <label for="idEmail" class="form-label">Work Email<span className="text-danger">*</span></label>
                                            <input
                                                type="text"
                                                className="form-control cstm_fromControl"
                                                id="idEmail"
                                                aria-describedby="idEmail"
                                                placeholder="Enter work email*"
                                                name="email"
                                                {...register('email', {
                                                    required: "Email is required",
                                                    pattern: {
                                                        value: /^(?!.*\.\.)(?!.*\.$)(?!.*\.\@)[^\s@]+@[^\s@]+\.[a-zA-Z]{2,}$/,
                                                        message: 'Invalid email',
                                                    },
                                                })}
                                            />
                                            {errors.email && (
                                                <p className="error-message text-danger">{errors.email.message}</p>
                                            )}
                                        </div>
                                    </div>

                                    <div className="col-xl-3 col-lg-3 col-md-3 col-sm-12 col-xs-12">
                                  
                                          <div className="mb-3">
                                            <label for="idEmail" class="form-label">Select Country Code<span className="text-danger">*</span></label>
                                            <input
                                                type="text"
                                                className="form-control cstm_fromControl"
                                                disabled
                                                id="idCountryCode"
                                                aria-describedby="idCountryCode"
                                                placeholder="+91"
                                                name="email"
                                                {...register('countryCode')}
                                            />
                                           
                                        </div>
                                    </div>
                                    <div className="col-xl-9 col-lg-9 col-md-9 col-sm-12 col-xs-12">
                                        <div className="mb-3">
                                            <label for="idCountryCode" class="form-label">Phone Number<span className="text-danger">*</span></label>
                                            {/* {
                                    selectedCountry == '+91' ?

                                        <input
                                            type="tel"
                                            className="form-control cstm_fromControl"
                                            id="idPhone"
                                            aria-describedby="idPhone"
                                            placeholder="Phone Number*"
                                            name="phone"
                                            maxLength={10}
                                            {...register('phone', {
                                                required: "Phone number is required",
                                                pattern: {
                                                    value: validationRules.indianPhone.pattern,
                                                    message: validationRules.indianPhone.message
                                                }
                                            })}
                                        />

                                        :

                                        <input
                                            type="tel"
                                            className="form-control cstm_fromControl"
                                            id="idPhone"
                                            aria-describedby="idPhone"
                                            placeholder="Phone Number*"
                                            name="phone"
                                            minLength={7}
                                            maxLength={10}
                                            {...register('phone', {
                                                required: "Phone number is required",
                                                pattern: {
                                                    value: validationRules.foreignPhone.pattern,
                                                    message: validationRules.foreignPhone.message
                                                }
                                            })}
                                        />
                                } */}

                                            <input
                                                type="tel"
                                                className="form-control cstm_fromControl"
                                                id="idPhone"
                                                aria-describedby="idPhone"
                                                placeholder="Enter phone number*"
                                                name="phone"
                                                maxLength={10}
                                                {...register('phone', phoneValidationRules)}
                                            />

                                            {errors.phone && (
                                                <p className="error-message text-danger" id="idPhoneError">{errors.phone.message}</p>
                                            )}
                                        </div>
                                    </div>

                                    <div className="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-xs-12">
                                        <div className="mb-3">
                                            <label for="idOrganisation" class="form-label">Organisation Name<span className="text-danger">*</span></label>
                                            <input
                                                type="text"
                                                className="form-control cstm_fromControl"
                                                id="idOrganisation"
                                                aria-describedby="idOrganisation"
                                                placeholder="Enter organisation name*"
                                                name="organisation"
                                                {...register('organisation', {
                                                    required: "Organisation name is required",
                                                    // pattern: {
                                                    //     value: validationRules.organizationName.pattern,
                                                    //     message: validationRules.organizationName.message
                                                    // }
                                                })}
                                            />
                                            {errors.organisation && (
                                                <p className="error-message text-danger">{errors.organisation.message}</p>
                                            )}
                                        </div>
                                    </div>

                                    <div className="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-xs-12">
                                        <div className="mb-3">
                                            <label for="idIndustry" class="form-label">Select Your Industry<span className="text-danger">*</span></label>
                                            <select
                                                className="form-select cstm_fromControl"
                                                aria-label="Default select example"
                                                {...register('industryId', { required: "Industry is required" })}>
                                                <option value="">Industry</option>
                                                {allIndustry.map((industry, index) => (
                                                    <option key={index} value={industry.industryId}>{industry.industryName}</option>
                                                ))}

                                            </select>
                                            {errors.industryId && (
                                                <p className="error-message text-danger">{errors.industryId.message}</p>
                                            )}
                                        </div>
                                    </div>

                                    <div className="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12">
                                        <div className="mb-3 datepicker_main">
                                            <label for="idStartDate" class="form-label">How soon would you like to start the training?<span className="text-danger">*</span></label>
                                            {/* <div className="calender_icon_main">
                                                <span
                                                    className="calender_icon"
                                                    onClick={() => datePickerRef.current.setOpen(true)}
                                                >
                                                    <i className="fa-solid fa-calendar-days"></i>
                                                </span>
                                            </div>
                                            <Controller
                                                control={control}
                                                name="beginDate"
                                                rules={{
                                                    required: "Start date is required",
                                                    pattern: {
                                                        value: /^\d{2}-\d{2}-\d{4}$/,
                                                        message: "Date must be in the format dd-mm-yyyy"
                                                    }
                                                }}
                                                render={({ field }) => (
                                                    <DatePicker
                                                        selected={field.value}
                                                        onChange={(date) => field.onChange(date)}
                                                        placeholderText="Select date"
                                                        minDate={minSelectableDate} // Set minimum selectable date
                                                        showMonthDropdown // Enable month dropdown
                                                        showYearDropdown // Enable year dropdown
                                                        dropdownMode="select" // Make dropdowns selectable
                                                        format="dd/mm/yyyy"
                                                        customInput={
                                                            <div
                                                                className="form-control cstm_div_fr_datepicker cstm_fromControl w-100 custom-datepicker-input"
                                                                id="idBeginDate"
                                                                aria-describedby="idBeginDate"
                                                                name="beginDate"
                                                                onClick={() => datePickerRef.current.setOpen(true)}
                                                                style={{
                                                                    color: field.value ? '#000' : '#6c757d',
                                                                }}
                                                            >
                                                                {field.value
                                                                    ? field.value.toLocaleDateString('en-GB')
                                                                    : 'Select date'}
                                                            </div>
                                                        }
                                                        wrapperClassName="date-picker-wrapper"
                                                        ref={datePickerRef}
                                                    />
                                                )}
                                            /> */}
                                                <select
                                                className="form-select cstm_fromControl"
                                                aria-label="Default select example"
                                                {...register('beginDate', { required: "Date is required" })}>
                                                <option value="">Select</option>
                                                {allDates.map((date, index) => (
                                                    <option key={index} value={date.value}>{date.label}</option>
                                                ))}
                                            </select>
                                            {/*  customInput={
                                        <input
                                            type="text"
                                            className="form-control cstm_fromControl w-100 cstm_date_input custom-datepicker-input"
                                            id="idBeginDate"
                                            aria-describedby="idBeginDate"
                                            name="beginDate"
                                            autoFocus="off"
                                        />
                                    } */}

                                            {errors.beginDate && (
                                                <p className="error-message text-danger">{errors.beginDate.message}</p>
                                            )}
                                        </div>
                                    </div>

                                    <div className="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12">
                                        <div className="mb-3 multiselect_main">
                                            <label for="exampleFormControlInput1" class="form-label">Select Courses<span className="text-danger">*</span></label>
                                            <Controller
                                                name="courseList"
                                                control={control}
                                                // rules={{ required: { value: true, message: "Please select at least one course" } }}
                                                render={({ field }) => (
                                                    <Multiselect
                                                        {...field}
                                                        options={coursesList}
                                                        displayValue="courseName"
                                                        className="custom-multiselect"
                                                        placeholder={placeholder}
                                                        selectionLimit={3}
                                                        selectedValues={defaultSelectedCourses}
                                                        disablePreSelectedValues
                                                        onRemove={selectedList => {
                                                            field.onChange(selectedList);
                                                            handleRemove(selectedList);
                                                        }}
                                                        onSelect={selectedList => {
                                                            field.onChange(selectedList);
                                                            handleSelect(selectedList);
                                                        }}
                                                    />
                                                )}
                                            />
                                            {errors.courseList && (
                                                <p className="error-message text-danger">{errors.courseList.message}</p>
                                            )}
                                        </div>
                                    </div>

                                    <div className="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12">
                                        <div className="mb-3">
                                            <label for="idMembers" class="form-label">Members to be trained?<span className="text-danger">*</span></label>
                                            <select
                                                className="form-select cstm_fromControl"
                                                aria-label="Default select example"
                                                {...register('membersId', { required: "Number of members is required" })}>
                                                <option value="">Members to be trained?</option>
                                                {allUserRange.map((members, index) => (
                                                    <option key={index} value={members.membersId}>{members.membersRange}</option>
                                                ))}
                                            </select>
                                            {errors.membersId && (
                                                <p className="error-message text-danger">{errors.membersId.message}</p>
                                            )}
                                        </div>
                                    </div>

                                    <div className="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12">
                                        <div className="mb-3">
                                            <label for="idComment" class="form-label">What are your organisation’s training needs? (optional)</label>
                                            <textarea
                                                className="form-control cstm_fromControl"
                                                id="exampleFormControlTextarea1"
                                                rows="5"
                                                maxLength={500}
                                                placeholder="What are your organisation’s training needs?"
                                                {...register('comment')}
                                            ></textarea>
                                        </div>
                                    </div>
                                </div>

                                <div className="inquery_check_main">
                                    <div className="form-check inquery_cstm_form_check_main">
                                        <input className="form-check-input cstm_check_inquery"
                                            type="checkbox"
                                            checked={agreement}
                                            id="agreement"
                                            onChange={handleAgreementChange}
                                        />
                                        <label className="form-check-label" for="agreementt">
                                            By providing your contact info, you agree to receive communications from Finlabs. You can <a href="#"><span className="focus_text">opt-out</span></a> at any time. For details, refer to our <a href="#"><span className="focus_text">Privacy Policy.</span></a>
                                        </label>
                                    </div>
                                </div>

                                <div className="enquery_form_submit_btn_area">
                                    <button className="enquery_form_submit">Submit</button>
                                </div>
                            </form>
                        </div>
                    </div>
                    <Footer />
                </>
            )

            }
        </React.Fragment>
    );
}

export default EnqueryForm;